/**
 * Print template cho Sổ Theo Dõi Chi Tiết Vốn Chủ Sở Hữu (S51-DN)
 * Tạo HTML printable từ data form
 */
export const getPrintTemplate = ({ headerInfo, rows, totals, closingBalance }) => {
  const fmt = (n) => (n ? new Intl.NumberFormat("vi-VN").format(n) : "");

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Sổ Theo Dõi Chi Tiết Vốn Chủ Sở Hữu (S51-DN)</title>
  <style>
    body { font-family: 'Times New Roman', serif; font-size: 12px; color: #000; }
    .header { display: flex; justify-content: space-between; margin-bottom: 15px; }
    .title-main { font-size: 16px; font-weight: bold; text-transform: uppercase; text-align: center; margin: 10px 0 20px 0; }
    table { width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 15px; }
    th, td { border: 1px solid #000; padding: 4px; text-align: center; vertical-align: middle; }
    .title-sub { font-weight: bold; font-style: italic; }
    .total-row { background-color: #f0f0f0; font-weight: bold; }
    .footer { margin-top: 20px; line-height: 1.8; }
    .signature { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
    .signature-box { width: 33%; }
    .signature-line { border-bottom: 1px solid #000; padding-top: 50px; }
    @media print { body { margin: 0; } }
  </style>
</head>
<body>
  <div class="header">
    <div style="width: 40%;">
      <div><strong>Đơn vị:</strong> ${headerInfo.company || ""}</div>
      <div><strong>Địa chỉ:</strong> ${headerInfo.companyAddress || ""}</div>
    </div>
    <div style="text-align: center; width: 60%;">
      <div><strong>Mẫu số S51-DN</strong></div>
      <div style="font-style: italic; font-size: 12px;">
        (Kèm theo TT 99/2025/TT-BTC ngày 27/10/2025 của BTC)
      </div>
    </div>
  </div>

  <div class="title-main">
    SỔ THEO DÕI CHI TIẾT VỐN ĐẦU TƯ CỦA CHỦ SỞ HỮU (TK 411)<br>
    <div>Năm: ${headerInfo.year || ""}</div>
  </div>

  <table>
    <thead>
      <tr>
        <th rowSpan="3">Ngày tháng<br>ghi sổ</th>
        <th colSpan="2">Chứng từ</th>
        <th rowSpan="3">Diễn giải</th>
        <th rowSpan="3">TK đối ứng</th>
        <th colSpan="8">Số phát sinh</th>
        <th colSpan="4">Số dư</th>
      </tr>
      <tr>
        <th rowSpan="2">Số hiệu</th>
        <th rowSpan="2">Ngày tháng</th>
        <th colSpan="4">Nợ (giảm)</th>
        <th colSpan="4">Có (tăng)</th>
        <th rowSpan="2">Vốn góp</th>
        <th rowSpan="2">Thặng dư vốn</th>
        <th rowSpan="2">Quyền chọn<br>chuyển đổi TP</th>
        <th rowSpan="2">Vốn khác</th>
      </tr>
      <tr>
        <th>Vốn góp</th><th>Thặng dư</th><th>Quyền chọn</th><th>Vốn khác</th>
        <th>Vốn góp</th><th>Thặng dư</th><th>Quyền chọn</th><th>Vốn khác</th>
      </tr>
    </thead>
    <tbody>
      <!-- Dư đầu kỳ -->
      <tr class="total-row">
        <td colSpan="3"></td>
        <td>- Số dư đầu kỳ</td>
        <td colSpan="9"></td>
        <td>${fmt(closingBalance?.contributedCapital)}</td>
        <td>${fmt(closingBalance?.sharePremium)}</td>
        <td>${fmt(closingBalance?.bondConversionOption)}</td>
        <td>${fmt(closingBalance?.otherCapital)}</td>
      </tr>
      
      <!-- Phát sinh -->
      <tr><td colSpan="4">- Số phát sinh trong kỳ:</td><td colSpan="9"></td></tr>
      ${rows
        .map(
          (row, i) => `
      <tr>
        <td>${row.recordingDate || ""}</td>
        <td>${row.documentNumber || ""}</td>
        <td>${row.documentDate || ""}</td>
        <td>${row.description || ""}</td>
        <td>${row.correspondingAccount || ""}</td>
        <td>${fmt(row.debit?.contributedCapital)}</td>
        <td>${fmt(row.debit?.sharePremium)}</td>
        <td>${fmt(row.debit?.bondConversionOption)}</td>
        <td>${fmt(row.debit?.otherCapital)}</td>
        <td>${fmt(row.credit?.contributedCapital)}</td>
        <td>${fmt(row.credit?.sharePremium)}</td>
        <td>${fmt(row.credit?.bondConversionOption)}</td>
        <td>${fmt(row.credit?.otherCapital)}</td>
        <td>${fmt(row.balance?.contributedCapital)}</td>
        <td>${fmt(row.balance?.sharePremium)}</td>
        <td>${fmt(row.balance?.bondConversionOption)}</td>
        <td>${fmt(row.balance?.otherCapital)}</td>
      </tr>
      `
        )
        .join("")}
      
      <!-- Cộng phát sinh -->
      <tr class="total-row">
        <td colSpan="3"></td>
        <td>- Cộng số phát sinh</td>
        <td>x</td>
        <td>${fmt(totals?.totalArisingDebit?.contributedCapital)}</td>
        <td>${fmt(totals?.totalArisingDebit?.sharePremium)}</td>
        <td>${fmt(totals?.totalArisingDebit?.bondConversionOption)}</td>
        <td>${fmt(totals?.totalArisingDebit?.otherCapital)}</td>
        <td>${fmt(totals?.totalArisingCredit?.contributedCapital)}</td>
        <td>${fmt(totals?.totalArisingCredit?.sharePremium)}</td>
        <td>${fmt(totals?.totalArisingCredit?.bondConversionOption)}</td>
        <td>${fmt(totals?.totalArisingCredit?.otherCapital)}</td>
        <td colSpan="4"></td>
      </tr>
      
      <!-- Dư cuối kỳ -->
      <tr class="total-row">
        <td colSpan="3"></td>
        <td>- Số dư cuối kỳ</td>
        <td colSpan="9"></td>
        <td>${fmt(closingBalance?.contributedCapital)}</td>
        <td>${fmt(closingBalance?.sharePremium)}</td>
        <td>${fmt(closingBalance?.bondConversionOption)}</td>
        <td>${fmt(closingBalance?.otherCapital)}</td>
      </tr>
    </tbody>
  </table>

  <div class="footer">
    <div>- Sổ này có <strong>${headerInfo.totalPages || ""}</strong> trang</div>
    <div>- Ngày mở sổ: <strong>${headerInfo.openingDate || ""}</strong></div>
  </div>

  <div class="signature">
    <div class="signature-box">
      <div>Người ghi sổ</div>
      <div class="signature-line">${headerInfo.preparerName || ""}</div>
    </div>
    <div class="signature-box">
      <div>Kế toán trưởng</div>
      <div class="signature-line">${headerInfo.chiefAccountantName || ""}</div>
    </div>
    <div class="signature-box">
      <div>Ngày ${headerInfo.signingDay || ""} tháng ${headerInfo.signingMonth || ""} năm ${
    headerInfo.signingYear || ""
  }</div>
      <div>Người đại diện theo pháp luật</div>
      <div class="signature-line">${headerInfo.legalRepresentativeName || ""}</div>
    </div>
  </div>

  <script>window.onload = () => window.print();</script>
</body>
</html>`;
};
